/* file description */
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import TopTableBtn from './TopTableBtn';
import useMetaStore from '@/store/useMetaStore';


export interface SpBusinessBtnsType {
  btnInfo: any;
  isRow?: boolean;
  openCallBack?: () => void;
  utils: any;
  record: any;
  moduleID: string;
  openDrawer?: boolean;
}

const TopTableBtns: React.FC<SpBusinessBtnsType> = forwardRef((props, ref) => {
  const { btnInfo, addTableData, moduleID, moduleList, addTableDataList, allData, metaInfoByRule } = props;
  const { isMobile } = useMetaStore();
  return (
    <>
      {btnInfo.map((btn, index) => {
        return (
          <TopTableBtn
            {...props}
            key={`${index}${btn!.text}`}
            btnInfo={btn}
            addTableData={addTableData}
            addTableDataList={addTableDataList}
            moduleID={moduleID}
            moduleList={moduleList}
            allData={allData}
            metaInfoByRule={metaInfoByRule}
            isMobile={isMobile}
          />
        );
      })}
    </>
  );
});

export default TopTableBtns;
